import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'app/material.module';
import { UIModule } from '@mrm/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ContactInfoFormComponent } from './components/contact-info-form/contact-info-form.component';
import { HeuPickerComponent } from './components/heu-picker/heu-picker.component';
import { SignaturePadModalComponent } from './components/signature-pad/signature-pad-modal.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { SectoralMeetingComponent } from './components/sectoral-meeting/sectoral-meeting.component';
import { SignatureRecipientComponent } from './components/signature-recipient/signature-recipient.component';
const COMMON_COMPONENTS = [
  HeuPickerComponent,
  ContactInfoFormComponent,
  SignaturePadModalComponent,
  SectoralMeetingComponent,
  SignatureRecipientComponent
];

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    UIModule,
    NgxPayPalModule
  ],
  declarations: [COMMON_COMPONENTS],
  exports: [
    COMMON_COMPONENTS,
    CommonModule,
    NgbModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgxPayPalModule,
    UIModule],
  entryComponents: [HeuPickerComponent],
  providers: []
})
export class EMREGCommonModule { }
